module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_300x250_3-d24ade9a11e96bebbf4082f15aa26276.jpg";